import Scorce from '../../assets/logos/scorce';
import GnpLogo from '../../assets/logos/gnpLogo.png';
import Google from '../../assets/logos/google';
import EyeIcon from '../../assets/icons/eye';
import { useState } from 'react';
import ErrorIcon from '../../assets/icons/error';
import LoadingIcon from '../../assets/icons/loading';
import ArrowBackIcon from '../../assets/icons/arrow-back';

function Login() {

  const [lang, setLang] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const [section, setSection] = useState("login"); // login - resetPassword

  const handleLogin = () => {

    setEmailError(email.length == 0)
    setPasswordError(password.length == 0)

    if (email.length == 0 || (section == "login" && password.length == 0)) return;

    setError(""); // Clear previous errors
    setLoading(true); // Set loading state

    setTimeout(() => {
      setLoading(false); // Stop loading after 4 seconds
      setError("Something is wrong, try again later");
    }, 4000);
  };

  const handleSection = (value) => {
    if (loading) return;
    setSection(value);
    setPassword("")
    setError("")
    setLoading(false)
    setEmailError(false)
    setPasswordError(false)
  }

  return (
    <div className="auth_container">
      <div className="login_form">
        <div className="login_wrapper">
          <div className="login_form_title">
            <img src={GnpLogo} className="logo_img" />
            <h1>
              {
                section == "login"
                  ?
                  lang == "spanish" ? "Iniciar sesión" : "Sign In"
                  :
                  lang == "spanish" ? "Forgot password?" : "¿Olvidó su contraseña?"
              }
            </h1>
            <p>{
              section == "login"
                ?
                lang == "spanish" ? "Introduce tus credenciales para acceder a tu cuenta." : "Enter your credentials to access your account."
                :
                lang == "spanish" ? "No se preocupe, le enviaremos instrucciones para restablecerla." : "No worries, we'll send you reset instructions."
            }</p>
          </div>
          <div className={"input_container" + (emailError ? " input_container_error" : "")}>
            <label>{lang == "spanish" ? "E-mail" : "Email address"}</label>
            <input
              type="text"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setEmailError(false) }}
            />
          </div>
          {
            section == "login" &&
            <div className={"input_container" + (passwordError ? " input_container_error" : "")}>
              <div className="input_label_flex">
                <label>{lang == "spanish" ? "Contraseña" : "Password"}</label>
                <span onClick={() => handleSection("resetPassword")}>{lang == "spanish" ? "¿Olvidaste tu contraseña?" : "Forgot password?"}</span>
              </div>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => { setPassword(e.target.value); setPasswordError(false) }}
              />
              <div className="password_visible_btn disable_select" onClick={() => setShowPassword(!showPassword)}>
                <EyeIcon />
              </div>
            </div>

          }
          <div className="login_action">
            {
              section == "resetPassword" &&
              <div class="login_back" onClick={() => handleSection("login")}>
                <ArrowBackIcon />
                <span>Login</span>
              </div>
            }
            {(loading || error) &&
              <div className={"btn btn_icon btn_indicator btn_primary" + (loading ? " btn_loading" : " btn_error")}>
                {loading ? <LoadingIcon /> : <ErrorIcon />}
              </div>
            }
            <div className={"btn btn_primary" + (loading ? " btn_loading" : "") + (section == "login" ? " btn_full_width" : "")} onClick={() => !loading ? handleLogin() : null}>
              <span>
                {
                  section == "login"
                    ?
                    lang == "spanish" ? "Iniciar sesión" : "Login"
                    :
                    lang == "spanish" ? "Restablecer contraseña" : "Reset Password"
                }
              </span>
            </div>
          </div>
          {
            section == "login" &&
            <>
              <div className="or_divider">
                <div className="divider"></div><span>{lang == "spanish" ? "o" : "or"}</span>
                <div className="divider"></div>
              </div>
              <div className="btn btn_social">
                <Google />
                <span>{lang == "spanish" ? "Iniciar sesión con Google" : "Log in with Google"}</span>
              </div>
            </>
          }
          <div className="power_by_scorce">
            <span>{lang == "spanish" ? "DESARROLLADO POR" : "POWERED BY"}</span>
            <Scorce />
          </div>
        </div>
        <div className="login_footer">
          <p className="copyright">© 2025 Scorce S.A.P.I. de C.V.</p>
          <p className="language">{lang == "spanish" ? "Idioma" : "Language"}: <span onClick={() => setLang("spanish")}>{lang == "spanish" ? "Español" : "Spanish"}</span> | <span onClick={() => setLang("english")}>{lang == "spanish" ? "Inglés" : "English"}</span></p>
        </div>
      </div>
    </div>
  );
}

export default Login;
